<form (ngSubmit)="onSearch()" class="c-searcharea" [formGroup]="formService.form" data-help-anchor="_verfahrenssuche">
	<div class="c-searchfield focus-outwards-dark">
		<button class="material-icons  focus-outwards-dark" type="button" (click)="openFilterDialog()"
		        matTooltip="Suchfilter auswählen"
		        aria-label="Suchfilter auswählen" aria-haspopup="menu" data-test-id="filter-button">
			<mat-icon [ngClass]="{'highlightFilter' : !allFiltersSelected}"
			          [attr.aria-label]="!allFiltersSelected ? 'Nicht alle Filter sind ausgewählt' : 'Alle Filter sind ausgewählt'">
				filter_alt
			</mat-icon>
		</button>
		<div class="separator"></div>
		<input type="search" [formControlName]="formService.fieldSearchString" name="searchString"
		       id="search-input" data-test-id="search-input" aria-label="Suchbegriff"
		       placeholder="Suchbegriff"/>
		<button class="material-icons focus-outwards-dark" type="button" (click)="formService.reset()"
		        data-test-id="clear-search-button" matTooltip="Suche und Filter zurücksetzen" aria-label="Suche und Filter zurücksetzen">
			<mat-icon>close</mat-icon>
		</button>
		<button class="material-icons focus-outwards-dark" type="submit" data-test-id="verfahren-search-button"
		        matTooltip="Verfahren suchen" aria-label="Verfahren suchen" (click)="hiddenFeature($event)">
			<mat-icon>search</mat-icon>
		</button>
	</div>
</form>
